import React, { useState } from 'react';
import { CentralCardLayout } from '@er/ui-lib';
import { useRouter } from 'next/router';
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';

import SnackBarErrorLayout from '@er/ui-lib/lib/common/shared/snackbar-error-layout';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useForm } from 'react-hook-form';
import validate from 'validate.js';
import SnackBarLayout from '@er/ui-lib/lib/common/shared/snackbar-layout';
import Link from 'next/link';
const labels = require('@er/ui-lib/lib/common/shared/labels.js');

type ForgotPasswordFormData = {
  email: string;
  password: string;
  remember: boolean;
};

const useStyles = makeStyles((theme) => ({
  content: {
    padding: 25,
  },
}));

function ForgotPassword() {
  const router = useRouter();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const classes = useStyles();

  const { handleSubmit, formState, control, errors } =
    useForm<ForgotPasswordFormData>({
      defaultValues: {
        email: '',
      },
    });

  const resetPassword = handleSubmit(async (data, e) => {
    e.preventDefault();

    await fetch(`/api/auth/send-reset-password-email`, {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      method: 'POST',
    })
      .then((r) => r.json())
      .then((result) => {
        if (result?.status === 'success') {
          setSuccessMessage(labels.ResetPasswordEmailSent);

          setOpenSuccessSnackbar(true);
        } else {
          setErrorMessage(result?.message);
          setOpenSnackbar(true);
        }
      });
  });

  const handleSuccessClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSuccessSnackbar(false);
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  return (
    <>
      <SnackBarLayout
        open={openSuccessSnackbar}
        handleClose={handleSuccessClose}
        message={successMessage}
      ></SnackBarLayout>
      <SnackBarErrorLayout
        open={openSnackbar}
        handleClose={handleClose}
        errorMessage={errorMessage}
      ></SnackBarErrorLayout>
      <CentralCardLayout>
        <div className={classes.content}>
          <Box textAlign="center" style={{ marginBottom: '48px' }}>
            <Typography variant="h5">
              <b>Forgot password?</b>
            </Typography>
          </Box>

          <Grid container direction="column" spacing={4}>
            <Grid item>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <Controller
                    control={control}
                    name="email"
                    rules={{
                      required: 'email is required',
                      validate: (value) => {
                        const err = validate.single(value, {
                          presence: true,
                          email: true,
                        });
                        if (!err) return;
                        return err[0];
                      },
                    }}
                    render={(
                      { onChange, onBlur, value, name, ref },
                      { invalid, isTouched, isDirty }
                    ) => (
                      <TextField
                        onBlur={onBlur}
                        fullWidth
                        variant="outlined"
                        label="Work email"
                        type="text"
                        inputRef={ref}
                        value={value}
                        error={invalid}
                        helperText={
                          <ErrorMessage
                            errors={formState.errors}
                            name={name as keyof ForgotPasswordFormData}
                          />
                        }
                        onChange={(e) => onChange(e.target.value)}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Box textAlign="center">
                    <Button
                      onClick={(e) => resetPassword(e)}
                      variant="contained"
                      size="large"
                      color="primary"
                      type="submit"
                      // disabled={
                      //   processing ||
                      //   !formState.isDirty ||
                      //   (formState.isDirty && !formState.isValid)
                      // }
                    >
                      Reset
                    </Button>
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    align="center"
                    style={{ marginTop: '24px' }}
                    color="primary"
                  >
                    <Link href="/">
                      <a style={{ textDecoration: 'none', color: 'inherit' }}>
                        Return To Login
                      </a>
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CentralCardLayout>
    </>
  );
}

export default ForgotPassword;
